import React from "react";

const CHUNK_RELOAD_KEY = "chunk_err_reload_ts";
const CHUNK_RELOAD_COOLDOWN_MS = 15000;

function isChunkError(error) {
  if (!error) return false;
  // webpack 5 throws ChunkLoadError; older builds use a message pattern
  return (
    error.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk \d+ failed/i.test(error.message)
  );
}

function reloadOnce() {
  const last = sessionStorage.getItem(CHUNK_RELOAD_KEY);
  if (!last || Date.now() - parseInt(last, 10) > CHUNK_RELOAD_COOLDOWN_MS) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, Date.now());
    window.location.reload();
    return true;
  }
  return false;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (isChunkError(error)) {
      reloadOnce();
      return;
    }
    console.error("ErrorBoundary caught:", error, info);
    if (typeof window.gtag === "function") {
      window.gtag("event", "exception", { description: error.message, fatal: true });
    }
  }

  render() {
    if (this.state.hasError) {
      if (isChunkError(this.state.error)) {
        // Reload is already triggered in componentDidCatch; show nothing while reloading.
        return null;
      }
      return (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h2>Something went wrong.</h2>
          <p style={{ color: "#888", marginBottom: "16px" }}>
            {this.state.error && this.state.error.message}
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            style={{ padding: "8px 24px", cursor: "pointer" }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
